/*
 *  Author: DL
 *  Date: 2020-12-03 09:53:55
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 12:06:51
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'dva';
import classnames from 'classnames';
import router from 'umi/router';
import { Alert, Button, Icon } from 'ui';
import SearchButton from '@/components/SearchButton';
import Shortcut from '@/components/Shortcut';
import ZoomControl from '@/components/ZoomControl';
import FloorControl from '@/components/FloorControl';
import ViewModeControl from '@/components/ViewModeControl';
import LayerModeControl from '@/components/LayerModeControl';
import LocationControl from '@/components/LocationControl';
import FmapProvider from '@/components/FmapProvider';
import { isEmpty } from 'utils/tools';

import styles from './index.less';

function Home(props) {
    const { dispatch } = props;
    const { fmap, listGroups, focusGroupId, visibleModel } = props;
    const { focusModel, current } = props.map;

    const [visible, setVisible] = useState(false);

    const handleInputClick = useCallback(() => {
        router.push(`/search?keyword=`);
    }, []);

    const handleBttnClick = useCallback(() => {
        router.push(`/route`);
    }, []);

    const handleShortcutClick = useCallback(keyword => {
        router.push(`/search?keyword=${keyword}`);
    }, []);

    const handleCloseInfo = useCallback(() => dispatch({ type: 'map/updateFocusModel', payload: { focusModel: {} } }), [dispatch]);

    const handleSimulateClick = useCallback(() => {
        if (isEmpty(current)) {
            setVisible(true);
        } else {
            dispatch({ type: 'map/updateCoords', payload: { coords: { start: { ...current }, end: { ...focusModel } } } });
            router.push('/scheme');
        }
    }, [dispatch, current, focusModel]);

    const mapClickNode = useCallback(
        event => {
            if (!event.target) return;
            const {
                mapCoord: { x, y },
                target: { FID, groupID, name, label = {} },
            } = event;

            if (!label.name) return;

            const floor = fmap.getFloorBygroupID(groupID);

            dispatch({ type: 'map/updateFocusModel', payload: { focusModel: { x, y, FID, groupID, name: name ? name.replace(/\%rn\%/, '') : '', floor } } });

            fmap.getMapCoordToCenter(FID);

            // 当前positionMarker
            const coordCenter = fmap.getMapCoordToCenter(FID);
            if (coordCenter) {
                fmap.updatePositionMarker(coordCenter);
            }
        },
        [dispatch, fmap],
    );

    useEffect(() => {
        const intervalTimer = setInterval(() => {
            if (fmap && fmap.loadCompleteStatus) {
                clearInterval(intervalTimer);

                fmap.map.on('mapClickNode', mapClickNode);

                return () => {
                    fmap.map.off('mapClickNode', mapClickNode);
                    fmap.visibleUpdatePositionMarke(false);
                    dispatch({ type: 'map/updateFocusModel', payload: { focusModel: {} } });
                };
            }
        });
    }, [fmap, mapClickNode, dispatch]);

    return (
        <FmapProvider value={{ fmap, listGroups, focusGroupId, current, visibleModel }}>
            <Alert message="当前没有定位点，无法路径规划" visible={visible} onClose={() => setVisible(false)} />
            <div className={styles.searchWrapper}>
                <SearchButton handleInputClick={handleInputClick} handleBttnClick={handleBttnClick} />
                <Shortcut onClick={handleShortcutClick} />
            </div>
            <div className={classnames({ [`${styles.controlWrapper}`]: true, [`${styles.infoWrapperBottom}`]: !isEmpty(focusModel) })}>
                <LocationControl />
                <LayerModeControl />
                <ViewModeControl />
                <FloorControl />
                <ZoomControl />
            </div>
            <InfoModal data={focusModel} onCloseClick={handleCloseInfo} onSimulateClick={handleSimulateClick} />
        </FmapProvider>
    );
}

export default connect(({ map }) => ({ map }))(Home);

function InfoModal(props) {
    const { data, onSimulateClick } = props;

    if (isEmpty(data)) return null;

    const { name, floor } = data;

    return (
        <div className={styles.infoWrapper}>
            <div className={styles.content}>
                <span>
                    {name} {floor}
                </span>
                <Button className={styles.close} onClick={props.onCloseClick}>
                    <Icon className="icongb002" />
                </Button>
            </div>
            <div className={styles.bttnWrapper}>
                <Button onClick={onSimulateClick} type="primary">
                    路径规划
                </Button>
            </div>
        </div>
    );
}
